import { RecordStatusEnum } from "@/pages/RecordsList/types";
import { formatAgendaDate } from "./formatAgendaDate";
import isValidTime from "./isValidTime";

const addIntervalToDate = (dateStr: string, interval: string, t?: (key: string) => string, recordingStatus?: number): string => {
  if (recordingStatus === RecordStatusEnum.READY_FOR_RECORDING) {
    return "-";
  }
  const isValidInterval = isValidTime(interval) ? interval : "00:00:00";

  const [hours, minutes, seconds] = isValidInterval.split(":").map(Number);
  const date = new Date(dateStr);

  if (Number.isNaN(date.getTime())) {
    return dateStr || "-";
  }

  date.setUTCHours(date.getUTCHours() + hours);
  date.setUTCMinutes(date.getUTCMinutes() + minutes);
  date.setUTCSeconds(date.getUTCSeconds() + seconds);

  const newInterval = formatAgendaDate(dateStr, date.toISOString(), null, null, t);

  return newInterval;
};

export default addIntervalToDate;
